// import React, { useState, useEffect } from 'react';
// import { ArrowRight, ArrowUpDown, BarChart2, Globe, Menu, X, ChevronDown, Shield, Users, Briefcase, Award, TrendingUp, Download } from 'lucide-react';

// const ServicesPage = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState('all');
//   const [isScrolled, setIsScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 10) {
//         setIsScrolled(true);
//       } else {
//         setIsScrolled(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const services = [
//     {
//       id: 1,
//       title: "Import & Export",
//       description: "Seamless cross-border precious metals trading with full compliance and logistics support.",
//       icon: <ArrowUpDown />,
//       category: "trading",
//       featured: true
//     },
//     {
//       id: 2,
//       title: "Market Analysis",
//       description: "Expert insights and real-time market data to inform your precious metals investment decisions.",
//       icon: <BarChart2 />,
//       category: "analysis",
//       featured: true
//     },
//     {
//       id: 3,
//       title: "Global Logistics",
//       description: "Secure transportation, storage, and handling of precious metals with comprehensive insurance.",
//       icon: <Globe />,
//       category: "logistics",
//       featured: true
//     },
//     {
//       id: 4,
//       title: "Compliance Consulting",
//       description: "Navigate complex regulatory frameworks with our specialized compliance consulting services.",
//       icon: <Shield />,
//       category: "consulting"
//     },
//     {
//       id: 5,
//       title: "Investment Advisory",
//       description: "Personalized investment strategies for high-net-worth individuals and institutional investors.",
//       icon: <TrendingUp />,
//       category: "analysis"
//     },
//     {
//       id: 6,
//       title: "Industry Research",
//       description: "Comprehensive research reports on precious metals markets, trends, and forecasts.",
//       icon: <Briefcase />,
//       category: "analysis"
//     }
//   ];

//   const filteredServices = activeTab === 'all' 
//     ? services 
//     : services.filter(service => service.category === activeTab);

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Navigation */}
//       <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`}>
//         <div className="container mx-auto px-4">
//           <div className="flex justify-between items-center">
//             <div className="flex items-center space-x-2">
//               <div className="h-10 w-10 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center">
//                 <Award className="text-white h-6 w-6" />
//               </div>
//               <span className="text-xl font-bold text-gray-800">GoldPro Trading</span>
//             </div>
            
//             <div className="hidden md:flex items-center space-x-8">
//               <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors">Home</a>
//               <a href="#" className="text-yellow-600 font-medium">Services</a>
//               <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors">About Us</a>
//               <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors">Markets</a>
//               <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors">Contact</a>
//             </div>
            
//             <div className="hidden md:block">
//               <button className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-2 rounded-lg font-medium transition-colors">
//                 Get Started
//               </button>
//             </div>
            
//             <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-gray-800">
//               {isOpen ? <X /> : <Menu />}
//             </button>
//           </div>
//         </div>
        
//         {/* Mobile menu */}
//         {isOpen && (
//           <div className="md:hidden bg-white shadow-xl rounded-b-lg mt-2 py-4 px-4 absolute w-full">
//             <div className="flex flex-col space-y-3">
//               <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors py-2">Home</a>
//               <a href="#" className="text-yellow-600 font-medium py-2">Services</a>
//               <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors py-2">About Us</a>
//               <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors py-2">Markets</a>
//               <a href="#" className="text-gray-600 hover:text-yellow-600 transition-colors py-2">Contact</a>
//               <button className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-2 rounded-lg font-medium transition-colors mt-2">
//                 Get Started
//               </button>
//             </div>
//           </div>
//         )}
//       </nav>

//       {/* Hero Section */}
//       <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-gray-100">
//         <div className="container mx-auto px-4">
//           <div className="max-w-3xl mx-auto text-center">
//             <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
//               Premium Services for <span className="text-yellow-600">Precious Metals</span> Trading
//             </h1>
//             <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
//               Comprehensive solutions for precious metals trading, from import and export to market analysis and specialized consulting.
//             </p>
//             <div className="flex flex-wrap justify-center gap-4">
//               <button className="bg-yellow-600 hover:bg-yellow-700 text-white px-8 py-3 rounded-lg font-medium transition-colors flex items-center">
//                 Explore Services <ArrowRight className="ml-2 h-4 w-4" />
//               </button>
//               <button className="bg-white border border-gray-300 hover:border-yellow-600 text-gray-800 hover:text-yellow-600 px-8 py-3 rounded-lg font-medium transition-colors flex items-center">
//                 Download Brochure <Download className="ml-2 h-4 w-4" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Services Filter */}
//       <section className="py-16">
//         <div className="container mx-auto px-4">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Premium Services</h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               Choose from our wide range of specialized services designed to meet all your precious metals trading needs.
//             </p>
//           </div>
          
//           <div className="flex flex-wrap justify-center gap-2 mb-12">
//             <button 
//               onClick={() => setActiveTab('all')}
//               className={`px-6 py-2 rounded-full font-medium transition-colors ${
//                 activeTab === 'all' 
//                   ? 'bg-yellow-600 text-white' 
//                   : 'bg-white text-gray-600 hover:bg-gray-100'
//               }`}
//             >
//               All Services
//             </button>
//             <button 
//               onClick={() => setActiveTab('trading')}
//               className={`px-6 py-2 rounded-full font-medium transition-colors ${
//                 activeTab === 'trading' 
//                   ? 'bg-yellow-600 text-white' 
//                   : 'bg-white text-gray-600 hover:bg-gray-100'
//               }`}
//             >
//               Trading
//             </button>
//             <button 
//               onClick={() => setActiveTab('analysis')}
//               className={`px-6 py-2 rounded-full font-medium transition-colors ${
//                 activeTab === 'analysis' 
//                   ? 'bg-yellow-600 text-white' 
//                   : 'bg-white text-gray-600 hover:bg-gray-100'
//               }`}
//             >
//               Analysis
//             </button>
//             <button 
//               onClick={() => setActiveTab('logistics')}
//               className={`px-6 py-2 rounded-full font-medium transition-colors ${
//                 activeTab === 'logistics' 
//                   ? 'bg-yellow-600 text-white' 
//                   : 'bg-white text-gray-600 hover:bg-gray-100'
//               }`}
//             >
//               Logistics
//             </button>
//             <button 
//               onClick={() => setActiveTab('consulting')}
//               className={`px-6 py-2 rounded-full font-medium transition-colors ${
//                 activeTab === 'consulting' 
//                   ? 'bg-yellow-600 text-white' 
//                   : 'bg-white text-gray-600 hover:bg-gray-100'
//               }`}
//             >
//               Consulting
//             </button>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {filteredServices.map((service) => (
//               <div key={service.id} className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:-translate-y-1 hover:shadow-xl">
//                 <div className="p-8">
//                   <div className="w-16 h-16 bg-yellow-100 rounded-2xl flex items-center justify-center mb-6 text-yellow-600">
//                     {service.icon}
//                   </div>
//                   <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
//                   <p className="text-gray-600 mb-4">
//                     {service.description}
//                   </p>
//                   <a href="#" className="text-yellow-600 hover:text-yellow-700 font-medium inline-flex items-center group">
//                     Learn More <ArrowRight size={16} className="ml-1 transition-transform group-hover:translate-x-1" />
//                   </a>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Why Choose Us */}
//       <section className="py-16 bg-gray-900 text-white">
//         <div className="container mx-auto px-4">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl font-bold mb-4">Why Choose GoldPro Trading</h2>
//             <p className="text-gray-300 max-w-2xl mx-auto">
//               We deliver exceptional service and value through our expertise and commitment to excellence.
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             <div className="bg-gray-800 p-6 rounded-xl">
//               <div className="w-12 h-12 bg-yellow-600 bg-opacity-20 rounded-full flex items-center justify-center mb-4">
//                 <Award className="text-yellow-500" size={24} />
//               </div>
//               <h3 className="text-xl font-bold mb-3">Industry Expertise</h3>
//               <p className="text-gray-400">
//                 Over 20 years of specialized experience in precious metals markets.
//               </p>
//             </div>
            
//             <div className="bg-gray-800 p-6 rounded-xl">
//               <div className="w-12 h-12 bg-yellow-600 bg-opacity-20 rounded-full flex items-center justify-center mb-4">
//                 <Shield className="text-yellow-500" size={24} />
//               </div>
//               <h3 className="text-xl font-bold mb-3">Secure Transactions</h3>
//               <p className="text-gray-400">
//                 Industry-leading security protocols for all trades and transfers.
//               </p>
//             </div>
            
//             <div className="bg-gray-800 p-6 rounded-xl">
//               <div className="w-12 h-12 bg-yellow-600 bg-opacity-20 rounded-full flex items-center justify-center mb-4">
//                 <Globe className="text-yellow-500" size={24} />
//               </div>
//               <h3 className="text-xl font-bold mb-3">Global Network</h3>
//               <p className="text-gray-400">
//                 Connected to major markets and suppliers across 40+ countries.
//               </p>
//             </div>
            
//             <div className="bg-gray-800 p-6 rounded-xl">
//               <div className="w-12 h-12 bg-yellow-600 bg-opacity-20 rounded-full flex items-center justify-center mb-4">
//                 <Users className="text-yellow-500" size={24} />
//               </div>
//               <h3 className="text-xl font-bold mb-3">Dedicated Support</h3>
//               <p className="text-gray-400">
//                 Personal account managers and 24/7 customer service team.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Call to Action */}
//       <section className="py-20 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between">
//             <div className="mb-6 md:mb-0">
//               <h2 className="text-3xl font-bold mb-2">Ready to get started?</h2>
//               <p className="text-yellow-100">
//                 Schedule a consultation with our precious metals experts today.
//               </p>
//             </div>
//             <div className="flex flex-wrap gap-4">
//               <button className="bg-white text-yellow-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-medium transition-colors">
//                 Contact Us
//               </button>
//               <button className="bg-transparent border border-white text-white hover:bg-white hover:bg-opacity-10 px-8 py-3 rounded-lg font-medium transition-colors">
//                 Learn More
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-gray-900 text-white pt-16 pb-8">
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
//             <div>
//               <div className="flex items-center space-x-2 mb-6">
//                 <div className="h-10 w-10 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center">
//                   <Award className="text-white h-6 w-6" />
//                 </div>
//                 <span className="text-xl font-bold">GoldPro Trading</span>
//               </div>
//               <p className="text-gray-400 mb-6">
//                 Your trusted partner in precious metals trading and investment services since 2005.
//               </p>
//             </div>
            
//             <div>
//               <h4 className="text-lg font-bold mb-6">Quick Links</h4>
//               <ul className="space-y-3">
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Home</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Services</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">About Us</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Markets</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Contact</a></li>
//               </ul>
//             </div>
            
//             <div>
//               <h4 className="text-lg font-bold mb-6">Services</h4>
//               <ul className="space-y-3">
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Import & Export</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Market Analysis</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Global Logistics</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Compliance Consulting</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Investment Advisory</a></li>
//               </ul>
//             </div>
            
//             <div>
//               <h4 className="text-lg font-bold mb-6">Contact Us</h4>
//               <ul className="space-y-3 text-gray-400">
//                 <li>123 Financial District</li>
//                 <li>New York, NY 10004</li>
//                 <li>info@goldprotrading.com</li>
//                 <li>+1 (212) 555-1234</li>
//               </ul>
//             </div>
//           </div>
          
//           <div className="border-t border-gray-800 pt-8">
//             <div className="flex flex-col md:flex-row md:justify-between md:items-center">
//               <p className="text-gray-500 mb-4 md:mb-0">
//                 © 2025 GoldPro Trading. All rights reserved.
//               </p>
//               <div className="flex space-x-4">
//                 <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Privacy Policy</a>
//                 <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Terms of Service</a>
//                 <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">Sitemap</a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default ServicesPage;

import React, { useState, useEffect } from 'react';
import { ArrowRight, ArrowUpDown, BarChart2, Globe, Menu, X, Shield, Users, Briefcase, Award, TrendingUp, Download } from 'lucide-react';
import service1 from '../assets/importexport.png'
import service2 from '../assets/marketanalysis.jpg'
import Footer from '../components/Footer';
import Header from '../components/Header';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('all');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      id: 1,
      title: "Import & Export",
      description: "Seamless cross-border precious metals trading with full compliance and logistics support.",
      icon: <ArrowUpDown />,
      category: "trading",
      featured: true
    },
    {
      id: 2,
      title: "Market Analysis",
      description: "Expert insights and real-time market data to inform your precious metals investment decisions.",
      icon: <BarChart2 />,
      category: "analysis",
      featured: true
    },
    {
      id: 3,
      title: "Global Logistics",
      description: "Secure transportation, storage, and handling of precious metals with comprehensive insurance.",
      icon: <Globe />,
      category: "logistics",
      featured: true
    },
    {
      id: 4,
      title: "Compliance Consulting",
      description: "Navigate complex regulatory frameworks with our specialized compliance consulting services.",
      icon: <Shield />,
      category: "consulting"
    },
    {
      id: 5,
      title: "Investment Advisory",
      description: "Personalized investment strategies for high-net-worth individuals and institutional investors.",
      icon: <TrendingUp />,
      category: "analysis"
    },
    {
      id: 6,
      title: "Industry Research",
      description: "Comprehensive research reports on precious metals markets, trends, and forecasts.",
      icon: <Briefcase />,
      category: "analysis"
    }
  ];

  const filteredServices = activeTab === 'all' 
    ? services 
    : services.filter(service => service.category === activeTab);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <Header />

      {/* Hero Section */}
      {/* <section className="pt-32 pb-16 bg-gradient-to-r from-gray-50 to-gray-100">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Premium Services for <span className="text-yellow-600">Precious Metals</span> Trading
            </h1>
            <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto">
              Comprehensive solutions for precious metals trading, from import and export to market analysis and specialized consulting.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <button className="bg-yellow-600 hover:bg-yellow-700 text-white px-8 py-3 rounded-lg font-medium transition-colors flex items-center">
                Explore Services <ArrowRight className="ml-2 h-4 w-4" />
              </button>
              <button className="bg-transparent border border-gray-300 hover:border-yellow-600 text-gray-800 hover:text-yellow-600 px-8 py-3 rounded-lg font-medium transition-colors flex items-center">
                Download Brochure <Download className="ml-2 h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </section> */}
            {/* Hero Section */}
            <section className="pt-32 pb-16 bg-gradient-to-br from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
              Premium Services for <span className="text-yellow-600">Precious Metals</span> Trading
            </h1>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
              Comprehensive solutions for precious metals trading, from import and export to market analysis and specialized consulting.
            </p>
            {/* <div className="flex flex-wrap justify-center gap-4">
              <button className="bg-yellow-600 hover:bg-yellow-700 text-white px-8 py-3 rounded-lg font-medium transition-colors flex items-center">
                Explore Services <ArrowRight className="ml-2 h-4 w-4" />
              </button>
              <button className="bg-white border border-gray-300 hover:border-yellow-600 text-gray-800 hover:text-yellow-600 px-8 py-3 rounded-lg font-medium transition-colors flex items-center">
                Download Brochure <Download className="ml-2 h-4 w-4" />
              </button>
            </div> */}
          </div>
        </div>
      </section>

      {/* Services Filter */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Premium Services</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Choose from our wide range of specialized services designed to meet all your precious metals trading needs.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            <button 
              onClick={() => setActiveTab('all')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'all' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              All Services
            </button>
            <button 
              onClick={() => setActiveTab('trading')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'trading' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Trading
            </button>
            <button 
              onClick={() => setActiveTab('analysis')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'analysis' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Analysis
            </button>
            <button 
              onClick={() => setActiveTab('logistics')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'logistics' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Logistics
            </button>
            <button 
              onClick={() => setActiveTab('consulting')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'consulting' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Consulting
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-20">
            {filteredServices.map((service) => (
              <div key={service.id} className="group relative">
                <div className="flex items-center mb-6">
                  <div className="text-yellow-600 mr-4">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-gray-600 mb-4 pl-10">
                  {service.description}
                </p>
                {/* <a href="#" className="text-yellow-600 hover:text-yellow-700 font-medium inline-flex items-center group pl-10">
                  Learn More <ArrowRight size={16} className="ml-1 transition-transform group-hover:translate-x-1" />
                </a> */}
                <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-yellow-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us - Horizontal Layout */}
      <section className="py-16 bg-gradient-to-r from-gray-900 to-gray-800 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Why Choose GoldPro Trading</h2>
            <p className="text-gray-300 max-w-2xl mx-auto">
              We deliver exceptional service and value through our expertise and commitment to excellence.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="border-l-2 border-yellow-500 pl-6">
              <div className="flex items-center mb-4">
                <Award className="text-yellow-500 mr-3" size={24} />
                <h3 className="text-xl font-bold">Industry Expertise</h3>
              </div>
              <p className="text-gray-400">
                Over 20 years of specialized experience in precious metals markets.
              </p>
            </div>
            
            <div className="border-l-2 border-yellow-500 pl-6">
              <div className="flex items-center mb-4">
                <Shield className="text-yellow-500 mr-3" size={24} />
                <h3 className="text-xl font-bold">Secure Transactions</h3>
              </div>
              <p className="text-gray-400">
                Industry-leading security protocols for all trades and transfers.
              </p>
            </div>
            
            <div className="border-l-2 border-yellow-500 pl-6">
              <div className="flex items-center mb-4">
                <Globe className="text-yellow-500 mr-3" size={24} />
                <h3 className="text-xl font-bold">Global Network</h3>
              </div>
              <p className="text-gray-400">
                Connected to major markets and suppliers across 40+ countries.
              </p>
            </div>
            
            <div className="border-l-2 border-yellow-500 pl-6">
              <div className="flex items-center mb-4">
                <Users className="text-yellow-500 mr-3" size={24} />
                <h3 className="text-xl font-bold">Dedicated Support</h3>
              </div>
              <p className="text-gray-400">
                Personal account managers and 24/7 customer service team.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Services - Alternating Layout */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Featured Services</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our most requested precious metals trading and investment services
            </p>
          </div>
          
          <div className="space-y-24">
            {/* Service 1 */}
            <div className="flex flex-col md:flex-row items-center">
              <div className="md:w-1/2 mb-8 md:mb-0 md:pr-12">
                <div className="inline-block text-yellow-600 mb-4">
                  <ArrowUpDown size={36} />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Import & Export Services</h3>
                <p className="text-gray-600 mb-6">
                  Our comprehensive import and export services streamline cross-border precious metals trading with full regulatory compliance and logistics support. We handle all documentation, customs clearance, and shipping arrangements to ensure smooth transactions.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-start">
                    <ArrowRight className="text-yellow-600 mr-2 mt-1 flex-shrink-0" size={16} />
                    <span>Complete customs documentation handling</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight className="text-yellow-600 mr-2 mt-1 flex-shrink-0" size={16} />
                    <span>Regulatory compliance assurance</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight className="text-yellow-600 mr-2 mt-1 flex-shrink-0" size={16} />
                    <span>Secure international shipping arrangements</span>
                  </li>
                </ul>
                {/* <a href="#" className="inline-flex items-center text-yellow-600 hover:text-yellow-700 font-medium group">
                  Learn More <ArrowRight className="ml-2 transition-transform group-hover:translate-x-1" size={16} />
                </a> */}
              </div>
              <div className="md:w-1/2">
                <div className="relative">
                  <div className="bg-yellow-100 rounded-lg w-full aspect-video flex items-center justify-center">
                    <img src={service1} alt="Import Export Services" className="rounded-lg" />
                  </div>
                  <div className="absolute -bottom-4 -right-4 bg-yellow-500 text-white py-2 px-4 rounded-lg">
                    Most Popular
                  </div>
                </div>
              </div>
            </div>
            
            {/* Service 2 */}
            <div className="flex flex-col md:flex-row-reverse items-center">
              <div className="md:w-1/2 mb-8 md:mb-0 md:pl-12">
                <div className="inline-block text-yellow-600 mb-4">
                  <BarChart2 size={36} />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Market Analysis</h3>
                <p className="text-gray-600 mb-6">
                  Stay ahead of market trends with our expert analysis and real-time data. Our team of analysts provides detailed reports, price forecasts, and trading recommendations to inform your precious metals investment decisions.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-start">
                    <ArrowRight className="text-yellow-600 mr-2 mt-1 flex-shrink-0" size={16} />
                    <span>Daily market reports and price alerts</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight className="text-yellow-600 mr-2 mt-1 flex-shrink-0" size={16} />
                    <span>Quarterly trend analysis and forecasting</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight className="text-yellow-600 mr-2 mt-1 flex-shrink-0" size={16} />
                    <span>Personalized investment recommendations</span>
                  </li>
                </ul>
                
              </div>
              <div className="md:w-1/2">
                <div className="bg-gray-100 rounded-lg w-full aspect-video flex items-center justify-center">
                  <img src={service2} alt="Market Analysis Services" className="rounded-lg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-yellow-600 text-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="mb-8 md:mb-0 md:w-3/5">
              <h2 className="text-3xl font-bold mb-4">Ready to get started?</h2>
              <p className="text-yellow-100 text-lg">
                Schedule a consultation with our precious metals experts today and discover how our services can help maximize your investment potential.
              </p>
            </div>
            <div className="md:w-2/5 md:text-right">
            <Link to='/contact'>
              <button className="bg-white text-yellow-600 hover:bg-yellow-50 px-8 py-3 rounded-lg font-medium transition-colors inline-flex items-center">
                Contact Us <ArrowRight className="ml-2" size={16} />
              </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
    <Footer />
    </div>
  );
};

export default ServicesPage;